// import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import { makeAuthenticatedRequest } from "../utils/apiRequest";
// import { useAuth } from "../contexts/authContext";

// const SightseeingPopup = ({
//   city,
//   filteredAttractions = [], // Renamed to 'filteredAttractions'
//   onClose,
//   onAdd,
//   editData = null,
// }) => {
//   const { token, currentUser } = useAuth();


//   // New state to track selected city
//   const [selectedCity, setSelectedCity] = useState(""); // New state for city

//   const [attractions, setAttractions] = useState([]);
//   const [selectedTicketDetails, setSelectedTicketDetails] = useState({});

//   const [ticketCategories, setTicketCategories] = useState([]);
//   const [selectedTicketCategory, setSelectedTicketCategory] = useState(
//     editData?.ticketCategory || ""
//   );

//   const [selectedTicketCategories, setSelectedTicketCategories] = useState({});
//   const [selectedAttraction, setSelectedAttraction] = useState(
//     editData?.location_name ? [editData.location_name] : [] // Auto-select the displayed attraction
//   );

//   const [type, setType] = useState(editData?.type || "Optional");
//   const [inclusion, setInclusion] = useState(editData?.inclusion ?? true);
//   const [notes, setNotes] = useState(editData?.notes || "");
//   const [arrangement, setArrangement] = useState(
//     editData?.arrangement || "Company Arrangement"
//   );

//   // Fetch relevant attractions for selected city
//   useEffect(() => {
//     const fetchAttractions = async () => {
//       if (selectedCity) {
//         try {
//           const response = await makeAuthenticatedRequest(
//             "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_hotel_location_data",
//             {
//               method: "POST",
//               headers: {
//                 Authorization: `Bearer ${token}`,
//                 "Content-Type": "application/json",
//               },
//               body: JSON.stringify({ city_name: [selectedCity] }),
//             }
//           );

//           if (!response.ok) throw new Error("Failed to fetch attractions.");

//           const data = await response.json();
//           setAttractions(data.data?.locations || []);
//         } catch (error) {
//           console.error("Error fetching attractions:", error.message);
//         }
//       }
//     };
//     fetchAttractions();
//   }, [selectedCity, token]);

//   const handleAdd = () => {
//     if (selectedAttraction.length === 0) {
//       alert("Please select at least one attraction.");
//       return;
//     }

//     const sightseeingData = selectedAttraction.map((attractionName) => {
//       const selectedAttractionDetails = attractions.find(
//         (attr) => attr.location_name === attractionName
//       );

//       return {
//         location_name: attractionName,
//         city_name: selectedCity, // New field: city name
//         location_id: selectedAttractionDetails?.location_id || "",
//         description: selectedAttractionDetails?.description || "",
//         type,
//         inclusion,
//         arrangement,
//         notes,
//       };
//     });

//     onAdd(sightseeingData[0]); // Pass back updated data
//     onClose();
//   };

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
//       <div className="bg-white rounded-lg p-6 shadow-lg w-96 max-h-[90vh] overflow-y-auto">
//         <div className="flex justify-between items-center mb-4">
//           <h2 className="text-xl font-bold">{editData ? "Edit Sightseeing" : "Add Sightseeing"}</h2>
//           <button onClick={onClose} className="text-gray-600 hover:text-black">
//             ✖
//           </button>
//         </div>

//         <div className="mb-4">
//           <label className="block text-sm font-medium text-gray-700">
//             Select Tourist Attractions:
//           </label>
//           <div className="flex flex-wrap gap-2 mt-2">
//             {filteredAttractions.map((attr) => (
//               <button
//                 key={attr.location_id}
//                 onClick={() => {
//                   setSelectedAttraction((prev) =>
//                     prev.includes(attr.location_name)
//                       ? prev.filter((name) => name !== attr.location_name)
//                       : [...prev, attr.location_name]
//                   );
//                 }}
//                 className={`px-4 py-2 rounded-full border ${
//                   selectedAttraction.includes(attr.location_name)
//                     ? "bg-blue-500 text-white border-blue-500"
//                     : "bg-gray-200 text-gray-700 border-gray-300"
//                 }`}
//               >
//                 {attr.location_name}
//               </button>
//             ))}
//           </div>
//         </div>

//         <div className="mb-4">
//   {selectedAttraction.map((attractionName) => {
//     const selectedAttractionDetails = attractions.find(
//       (attr) => attr.location_name === attractionName
//     );

//     if (!selectedAttractionDetails) {
//       return (
//         <p key={attractionName} className="text-sm text-gray-400">
//           No details available for {attractionName}.
//         </p>
//       );
//     }

//     const ticketFees =
//       typeof selectedAttractionDetails.tickets_price === "object" &&
//       !Array.isArray(selectedAttractionDetails.tickets_price)
//         ? [selectedAttractionDetails.tickets_price]
//         : selectedAttractionDetails.tickets_price || [];

//     const allCategories = ticketFees.flatMap((category) =>
//       typeof category === "object" ? Object.keys(category) : []
//     );

//     if (allCategories.length === 0) {
//       return (
//         <p key={attractionName} className="text-sm text-gray-400">
//           No ticket categories available for {attractionName}.
//         </p>
//       );
//     }

//     return (
//       <div key={attractionName} className="mt-4">
//         <p className="font-semibold text-gray-600">{attractionName}</p>
//         <div className="mt-2">
//           <label className="block text-sm font-medium text-gray-700">
//             Select Ticket Category:
//           </label>
//           <select
//             value={selectedTicketCategories[attractionName] || ""}
//             onChange={(e) =>
//               setSelectedTicketCategories((prev) => ({
//                 ...prev,
//                 [attractionName]: e.target.value,
//               }))
//             }
//             className="w-full p-2 border border-gray-300 rounded mt-1"
//           >
//             <option value="">-- Select Category --</option>
//             {allCategories.map((key, index) => (
//               <option key={`${index}-${key}`} value={key}>
//                 {key.replace(/_/g, " ")}
//               </option>
//             ))}
//           </select>
//         </div>
//         <div className="mt-2">
//   <p className="font-medium text-gray-500">Details:</p>
//   <ul className="list-disc pl-4 text-gray-500">
//     {Object.entries(
//       selectedAttractionDetails?.tickets_price[selectedTicketCategories[attractionName]] || {}
//     ).map(([key, value]) => (
//       <li key={key} className="flex items-center space-x-2">
//         <span>{key.replace(/_/g, " ")}:</span>
//         <input
//           type="number"
//           value={selectedTicketDetails[attractionName]?.[key] ?? value}
//           onChange={(e) => {
//             const newValue = e.target.value;
//             setSelectedTicketDetails((prevDetails) => ({
//               ...prevDetails,
//               [attractionName]: {
//                 ...prevDetails[attractionName],
//                 [key]: newValue,
//               },
//             }));
//           }}
//           className="w-20 border border-gray-300 rounded px-2 py-1"
//         />
//       </li>
//     ))}
//   </ul>
// </div>

//       </div>
//     );
//   })}
// </div>

//         <div className="mb-4">
//           <label className="block text-sm font-medium text-gray-700">Type:</label>
//           <select
//             value={type}
//             onChange={(e) => setType(e.target.value)}
//             className="w-full p-2 border border-gray-300 rounded mt-1"
//           >
//             <option value="Optional">Optional</option>
//             <option value="Mandatory">Mandatory</option>
//           </select>
//         </div>

//         <div className="mb-4">
//           <label className="block text-sm font-medium text-gray-700">
//             Inclusion/Exclusion:
//           </label>
//           <div className="flex space-x-4 mt-1">
//             <button
//               onClick={() => setInclusion(true)}
//               className={`px-4 py-2 rounded border w-full text-center ${
//                 inclusion ? "bg-blue-500 text-white" : "bg-gray-100 text-gray-700"
//               }`}
//             >
//               Included
//             </button>
//             <button
//               onClick={() => setInclusion(false)}
//               className={`px-4 py-2 rounded border w-full text-center ${
//                 !inclusion
//                   ? "bg-blue-500 text-white"
//                   : "bg-gray-100 text-gray-700"
//               }`}
//             >
//               Excluded
//             </button>
//           </div>
//         </div>

//         <div className="mb-4">
//           <label className="block text-sm font-medium text-gray-700">
//             Arrangement:
//           </label>
//           <div className="flex space-x-4 mt-1">
//             <button
//               onClick={() => setArrangement("Company Arrangement")}
//               className={`px-4 py-2 rounded border w-full text-center ${
//                 arrangement === "Company Arrangement"
//                   ? "bg-blue-500 text-white"
//                   : "bg-gray-100 text-gray-700"
//               }`}
//             >
//               Company Arrangement
//             </button>
//             <button
//               onClick={() => setArrangement("Own Arrangement")}
//               className={`px-4 py-2 rounded border w-full text-center ${
//                 arrangement === "Own Arrangement"
//                   ? "bg-blue-500 text-white"
//                   : "bg-gray-100 text-gray-700"
//               }`}
//             >
//               Own Arrangement
//             </button>
//           </div>
//         </div>

//         <div className="mb-4">
//           <label className="block text-sm font-medium text-gray-700">
//             Special Notes:
//           </label>
//           <textarea
//             value={notes}
//             onChange={(e) => setNotes(e.target.value)}
//             className="w-full p-2 border border-gray-300 rounded mt-1"
//           />
//         </div>

//         <button
//           onClick={handleAdd}
//           className="bg-blue-500 text-white px-4 py-2 rounded w-full"
//         >
//           {editData ? "Save Changes" : "Add Sightseeing"}
//         </button>
//       </div>
//     </div>
//   );

// };

// export default SightseeingPopup;

import React, { useState, useEffect } from "react";

import { makeAuthenticatedRequest } from "../utils/apiRequest";
import { useAuth } from "../contexts/authContext";

const SightseeingPopup = ({
  city,
  filteredAttractions = [], // Renamed to 'filteredAttractions'
  onClose,
  onAdd,
  editData = null,
}) => {
  const { token } = useAuth();

  // New state to track selected city and available cities
  const [selectedCity, setSelectedCity] = useState(""); // New state for city
  const [availableCities, setAvailableCities] = useState([]); // New state for fetched cities
  
  // State for tax percentage
  const [taxPercentage, setTaxPercentage] = useState(0);

  const [attractions, setAttractions] = useState([]);
  const [selectedTicketDetails, setSelectedTicketDetails] = useState({});

  const [selectedTicketCategories, setSelectedTicketCategories] = useState(
    editData?.ticketCategory
      ? { [editData.location_name]: editData.ticketCategory }
      : {}
  );

  const [selectedAttraction, setSelectedAttraction] = useState(
    editData?.location_name ? [editData.location_name] : [] // Auto-select the displayed attraction
  );

  const [type, setType] = useState(editData?.type || "Optional");
  const [inclusion, setInclusion] = useState(
    editData?.inclusion === false || editData?.inclusion === "False"
      ? false
      : true
  );
  const [notes, setNotes] = useState(editData?.notes || "");
  const [arrangement, setArrangement] = useState(
    editData?.arrangement || "Company Arrangement"
  );

  const [ticketCategories, setTicketCategories] = useState({});

  // Fetch all taxes and store them in a map by tax name
  const [taxMap, setTaxMap] = useState({});
  
  useEffect(() => {
    const fetchTaxes = async () => {
      try {
        const response = await makeAuthenticatedRequest(
          "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_all_taxes",
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) throw new Error("Failed to fetch tax data.");

        const data = await response.json();
        
        // Create a map of tax_name -> tax_percentage for easy lookup
        if (data && data.data && data.data.length > 0) {
          const taxMapping = {};
          
          data.data.forEach(tax => {
            if (tax.tax_name && tax.tax_percentage) {
              taxMapping[tax.tax_name] = parseFloat(tax.tax_percentage);
            }
          });
          
          setTaxMap(taxMapping);
          
          // Set default tax percentage from the first tax entry for backward compatibility
          if (data.data[0] && data.data[0].tax_percentage) {
            const taxValue = parseFloat(data.data[0].tax_percentage);
            setTaxPercentage(taxValue);
            console.log("Default Tax Percentage:", taxValue);
          }
          
          console.log("Tax Map:", taxMapping);
        }
      } catch (error) {
        console.error("Error fetching tax data:", error.message);
      }
    };

    fetchTaxes();
  }, [token]);

  // Fetch all cities
  useEffect(() => {
    const fetchCities = async () => {
      try {
        const response = await makeAuthenticatedRequest(
          "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_all_cities",
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) throw new Error("Failed to fetch cities.");

        const data = await response.json();
        setAvailableCities(data.data || []);
      } catch (error) {
        console.error("Error fetching cities:", error.message);
      }
    };

    fetchCities();
  }, [token]);

  // Fetch relevant attractions based on selected city
  // Fetch relevant attractions based on selected city
  useEffect(() => {
    const fetchAttractions = async () => {
      if (selectedCity && !editData) {
        try {
          const response = await makeAuthenticatedRequest(
            "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_hotel_location_data",
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ city_name: [selectedCity] }),
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch attractions.");
          }

          const data = await response.json();
          
          // Process attractions and respect the API's taxAvailable property and taxDetails if present
          const processedAttractions = (data?.data?.locations || []).map(attraction => {
            // Use the API's taxAvailable property directly if it exists,
            // otherwise determine it from other properties
            const taxAvailable = attraction.hasOwnProperty('taxAvailable') 
              ? attraction.taxAvailable 
              : attraction.hasOwnProperty('tax_info') || 
                (attraction.tax_percentage && attraction.tax_percentage > 0) || 
                attraction.hasOwnProperty('taxable');
            
            // Extract tax details and enrich with tax percentages from taxMap if available
            const taxDetails = (attraction.taxDetails || []).map(taxDetail => {
              // If the tax detail already has a percentage, use it
              if (taxDetail.tax_percentage) {
                return taxDetail;
              }
              
              // Otherwise, look up the percentage in our taxMap using the tax_name
              if (taxDetail.tax_name && taxMap[taxDetail.tax_name]) {
                return {
                  ...taxDetail,
                  tax_percentage: taxMap[taxDetail.tax_name]
                };
              }
              
              // If no match found, return the original detail
              return taxDetail;
            });
            
            return {
              ...attraction,
              taxAvailable, // Add or update taxAvailable flag to each attraction
              taxDetails    // Include the enriched tax details array
            };
          });
          
          setAttractions(processedAttractions);
          console.log("Attractions with tax info:", processedAttractions);

          // Extract ticket categories from the attractions
          const categories = processedAttractions.reduce((acc, attraction) => {
            const tickets = attraction.tickets_price || {};
            Object.keys(tickets).forEach((category) => {
              if (!acc[category]) acc[category] = tickets[category];
            });
            return acc;
          }, {});

          // Store the available ticket categories
          setTicketCategories(categories);
        } catch (error) {
          console.error("Error fetching attractions:", error.message);
        }
      }
    };

    fetchAttractions();
  }, [selectedCity, token, editData]);

  const handleAdd = () => {
    if (!selectedAttraction.length) {
      alert("Please select at least one attraction.");
      return;
    }

    const sightseeingData = selectedAttraction.map((attractionName) => {
      const selectedAttractionDetails =
        attractions.find((attr) => attr.location_name === attractionName) ||
        editData;

      const selectedCategoryData =
        selectedTicketCategories[attractionName] || {};

      const selectedCategory = selectedCategoryData.category;
      const selectedTicketPrice = selectedCategoryData.price || {};

      // Determine ticket availability based on non-empty adult or children values
      const tickets = selectedAttractionDetails?.tickets_price || {};
      let ticketAvailability = false;

      for (const category in tickets) {
        const { adults, children } = tickets[category] || {};

        // Check if adults or children have valid, non-empty values
        if (
          (adults && adults.trim() !== "") ||
          (children && children.trim() !== "")
        ) {
          ticketAvailability = true;
          break;
        }
      }
      
      // Calculate tax prices for ALL locations regardless of taxAvailable status
      // Initialize taxedPrices as an empty object to ensure it's always included in the output
      let taxedPrices = {};
      
      if (selectedCategory && selectedTicketPrice) {
        // Create a structure to match what's used in the JSON output
        taxedPrices[selectedCategory] = {};
        
        // Get tax details from attraction or use default tax percentage
        const taxDetails = selectedAttractionDetails?.taxDetails || [];
        
        // Calculate tax for each price type (adults, children, etc.)
        Object.entries(selectedTicketPrice).forEach(([priceType, basePrice]) => {
          // Remove currency symbols before parsing
          const cleanValue = typeof basePrice === 'string' ? basePrice.replace(/[^0-9.-]+/g, '') : basePrice;
          const parsedBasePrice = parseFloat(cleanValue) || 0;
          
          if (parsedBasePrice <= 0) return; // Skip invalid prices
          
          // CASE 1: Use specific tax details if available
          if (taxDetails.length > 0) {
            taxDetails.forEach(tax => {
              // Get the tax percentage from the tax object or look it up in the taxMap
              const taxPercentage = tax.tax_percentage || 
                                 (tax.tax_name && taxMap[tax.tax_name]) || 
                                 0;
              
              if (taxPercentage > 0) {
                const priceWithTax = parsedBasePrice * ((100 + taxPercentage) / 100);
                
                if (!isNaN(priceWithTax)) {
                  // Store the tax calculation for this tax type
                  taxedPrices[selectedCategory][`${priceType}_with_tax`] = priceWithTax.toFixed(2);
                }
              }
            });
          } 
          // CASE 2: Use general tax percentage as fallback
          else if (taxPercentage > 0) {
            const priceWithTax = parsedBasePrice * ((100 + taxPercentage) / 100);
            
            if (!isNaN(priceWithTax)) {
              taxedPrices[selectedCategory][`${priceType}_with_tax`] = priceWithTax.toFixed(2);
            }
          }
          // CASE 3: No tax information available, use 0% tax as fallback
          else {
            // Even for locations with taxAvailable:false, include the price in taxedPrices
            // This makes the structure consistent across all attractions
            taxedPrices[selectedCategory][`${priceType}_with_tax`] = parsedBasePrice.toFixed(2);
          }
        });
        
        // Always keep taxedPrices in the output, even if empty
        // This ensures taxedPrices will be included in the JSON output for all locations
      }

      return {
        activity_type: "sightseeing",
        city: selectedCity,
        location_name: attractionName,
        location_id: selectedAttractionDetails?.location_id || "",
        description:
          selectedAttractionDetails?.description || "No description available",
        location_img_path: selectedAttractionDetails?.location_img_path || [],
        type: type || "Optional",
        inclusion: inclusion ?? true,
        arrangement,
        notes: notes || "",
        tickets_price: selectedAttractionDetails?.tickets_price || {},
        selectedTicketCategories,
        ticketCategory: selectedCategory,
        ticketPrice: selectedTicketPrice,
        taxAvailable: selectedAttractionDetails?.taxAvailable || false, // Include tax availability status
        taxDetails: selectedAttractionDetails?.taxDetails || [], // Include specific tax details from the API
        tax_percentage: selectedAttractionDetails?.taxDetails?.[0]?.tax_percentage || taxPercentage, // Use specific tax percentage if available
        ticketAvailability, // Add ticketAvailability flag
        taxedPrices, // Include the calculated tax prices
      };
    });

    console.log("Sightseeing Data:", sightseeingData);
    onAdd(sightseeingData);
    onClose();
  };

  // Add this useEffect to handle ticket data initialization
  useEffect(() => {
    if (editData) {
      // Set the selected city
      setSelectedCity(editData.city || "");

      // Set selected attraction
      if (editData.location_name) {
        setSelectedAttraction([editData.location_name]);
      }

      // Initialize ticket details if available
      if (editData.tickets) {
        // Set the selected ticket category
        const category = Object.keys(editData.tickets)[0];
        if (category) {
          setSelectedTicketCategories({
            [editData.location_name]: {
              category: category,
              price: editData.tickets[category],
            },
          });

          // Set the ticket details
          setSelectedTicketDetails({
            [editData.location_name]: editData.tickets[category],
          });
        }
      }
    }
  }, [editData]);

  // Dependencies: only re-run when editData changes

  // Add this useEffect hook to log editData in the console
  // useEffect(() => {
  //   if (editData) {
  //     console.log("Edit Data from sightseeing:", editData);
  //   }
  // }, [editData]);

  // Ensure ticket details are correctly set when attractions change
  // useEffect(() => {
  //   if (selectedAttraction.length > 0 || editData) {
  //     const selectedAttractionDetails = attractions.find(
  //       (attr) => attr.location_name === selectedAttraction[0]
  //     ) || editData;

  //     if (selectedAttractionDetails) {
  //       setSelectedTicketDetails(selectedAttractionDetails.tickets_price || {});

  //       // **FIX APPLIED: Auto-select the first available category if not already set**
  //       const firstCategory = Object.keys(selectedAttractionDetails.tickets_price || {});
  //       if (firstCategory && !selectedTicketCategories[selectedAttraction[0]]) {
  //         setSelectedTicketCategories((prev) => ({
  //           ...prev,
  //           [selectedAttraction[0]]: firstCategory,
  //         }));
  //       }
  //     }
  //   }
  // }, [selectedAttraction, attractions, editData]);

  // useEffect(() => {
  //   if (editData?.ticket_prices) {
  //     console.log("Edit Data - Ticket Prices:");

  //     Object.entries(editData.ticket_prices).forEach(([category, details]) => {
  //       console.log(`Category: ${category}`);
  //       Object.entries(details).forEach(([key, value]) => {
  //         console.log(`  ${key}: ${value}`);
  //       });
  //     });
  //   }
  // }, [editData]);

  // useEffect(() => {
  //   // Log selectedTicketDetails when they change
  //   console.log("Selected Ticket Details:", selectedTicketDetails);
  // }, [selectedTicketDetails]);

  // useEffect(() => {
  //   // Log selectedTicketCategories when they change
  //   console.log("Selected Ticket Categories:", selectedTicketCategories);
  // }, [selectedTicketCategories]);

  useEffect(() => {
    if (
      editData?.ticketCategory &&
      editData?.ticketPrice &&
      editData?.location_name
    ) {
      setSelectedTicketCategories({
        [editData.location_name]: {
          category: editData.ticketCategory,
          price: editData.ticketPrice,
        },
      });
      setSelectedAttraction([editData.location_name]); // reselect attraction
    }
  }, [editData]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
      <div className="bg-white rounded-lg p-6 shadow-lg w-1/2 max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">
            {editData ? "Edit Sightseeing" : "Add Sightseeing"}
          </h2>
          <button onClick={onClose} className="text-gray-600 hover:text-black">
            ✖
          </button>
        </div>
        {/* City Dropdown - visible only for Add Sightseeing */}
        {!editData && (
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Select City:
            </label>
            <select
              value={selectedCity}
              onChange={(e) => setSelectedCity(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded mt-1"
            >
              <option value="">-- Select City --</option>
              {availableCities.map((city) => (
                <option key={city.city_id} value={city.city_name}>
                  {city.city_name}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Tourist Attractions - only shown after a city is selected */}
        {selectedCity && !editData && (
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Select Tourist Attractions:
            </label>
            <div className="flex flex-wrap gap-2 mt-2">
              {attractions.map((attr) => (
                <button
                  key={attr.location_id}
                  onClick={() => {
                    setSelectedAttraction((prev) =>
                      prev.includes(attr.location_name)
                        ? prev.filter((name) => name !== attr.location_name)
                        : [...prev, attr.location_name]
                    );
                  }}
                  className={`px-4 py-2 rounded-full border ${
                    selectedAttraction.includes(attr.location_name)
                      ? "bg-blue-500 text-white border-blue-500"
                      : "bg-gray-200 text-gray-700 border-gray-300"
                  }`}
                >
                  {attr.location_name}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* This section is only visible in the "Edit Sightseeing" popup */}
        {/* This section is only visible in the "Edit Sightseeing" popup */}
        {editData && (
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Select Tourist Attractions:
            </label>
            <div className="flex flex-wrap gap-2 mt-2">
              {filteredAttractions.map((attr) => (
                <button
                  key={attr.location_id}
                  onClick={() => {
                    setSelectedAttraction((prev) =>
                      prev.includes(attr.location_name)
                        ? prev.filter((name) => name !== attr.location_name)
                        : [...prev, attr.location_name]
                    );
                  }}
                  className={`px-4 py-2 rounded-full border ${
                    selectedAttraction.includes(attr.location_name)
                      ? "bg-blue-500 text-white border-blue-500"
                      : "bg-gray-200 text-gray-700 border-gray-300"
                  }`}
                >
                  {attr.location_name}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Display Ticket Category and Prices only in "Edit Sightseeing" */}
        {editData &&
          selectedAttraction.length > 0 &&
          selectedAttraction.map((attractionName) => {
            const selectedAttractionDetails =
              attractions.find(
                (attr) => attr.location_name === attractionName
              ) || editData;

            if (!selectedAttractionDetails) return null;

            const ticketFees = selectedAttractionDetails?.tickets_price || {}; // Get tickets from the response

            console.log(`Selected Attraction: ${attractionName}`);
            console.log("Attraction Details:", selectedAttractionDetails);
            console.log("Ticket Details:", ticketFees);

            return (
              <div key={attractionName} className="mt-4">
                <p className="font-semibold text-gray-600">{attractionName}</p>

                {/* Select Ticket Category */}
                <div className="mt-2">
                  <label className="block text-sm font-medium text-gray-700">
                    Select Ticket Category:
                  </label>
                  <select
                    value={
                      selectedTicketCategories[attractionName]?.category 
                    }
                    onChange={(e) => {
                      const selectedCategory = e.target.value;
                      const selectedPrice = ticketFees[selectedCategory] || {};

                      setSelectedTicketCategories((prev) => ({
                        ...prev,
                        [attractionName]: {
                          category: selectedCategory,
                          price: selectedPrice,
                        },
                      }));
                    }}
                    className="w-full p-2 border border-gray-300 rounded mt-1"
                  >
                    <option value="">-- Select Category --</option>
                    {Object.keys(ticketFees).map((category) =>
                      ticketFees[category].adults ||
                      ticketFees[category].children ? (
                        <option key={category} value={category}>
                          {category.replace(/_/g, " ")}{""}
                          {/* Format category name */}
                        </option>
                      ) : null
                    )}
                  </select>
                </div>

                {/* Display Ticket Prices for the selected category */}
                <div className="mt-2">
                  <p className="font-medium text-gray-500">Ticket Prices:</p>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <p className="text-sm font-medium text-gray-600 mb-1">Base Price:</p>
                      <ul className="list-disc pl-4 text-gray-500">
                        {selectedTicketCategories[attractionName]?.price &&
                          Object.entries(
                            selectedTicketCategories[attractionName]?.price
                          ).map(([key, value]) => (
                            <li key={key} className="flex items-center space-x-2 mb-1">
                              <span>{key.replace(/_/g, " ")}:</span>
                              <input
                                type="text"
                                value={value || "Not Available"}
                                className="w-24 border border-gray-300 rounded px-2 py-1"
                                readOnly
                              />
                            </li>
                          ))}
                      </ul>
                    </div>
                    
                    {/* Only show tax prices if taxAvailable is true */}
                    {selectedAttractionDetails?.taxAvailable && (
                      <div>
                        {/* Get tax details from the attraction data */}
                        {selectedAttractionDetails.taxDetails && selectedAttractionDetails.taxDetails.length > 0 ? (
                          <>
                            {selectedAttractionDetails.taxDetails.map((tax, taxIndex) => {
                              // Get the tax percentage from the tax object or look it up in the taxMap
                              const taxPercentage = tax.tax_percentage || 
                                                  (tax.tax_name && taxMap[tax.tax_name]) || 
                                                  0;
                              
                              return (
                                <div key={tax.tax_id || taxIndex}>
                                  <p className="text-sm font-medium text-gray-600 mb-1">
                                    With {tax.tax_name} ({taxPercentage}%):
                                  </p>
                                  <ul className="list-disc pl-4 text-gray-500">
                                    {selectedTicketCategories[attractionName]?.price &&
                                      Object.entries(
                                        selectedTicketCategories[attractionName]?.price
                                      ).map(([key, value]) => {
                                        // Remove currency symbols (like $) before parsing the value
                                        const cleanValue = typeof value === 'string' ? value.replace(/[^0-9.-]+/g, '') : value;
                                        
                                        // Calculate price with tax using the formula: basePrice * ((100 + taxPercentage) / 100)
                                        const basePrice = parseFloat(cleanValue) || 0;
                                        const priceWithTax = basePrice * ((100 + taxPercentage) / 100);
                                        
                                        // Format to 2 decimal places if it's a valid number and add $ symbol
                                        const formattedPrice = !isNaN(priceWithTax) && basePrice > 0 
                                          ? `$ ${priceWithTax.toFixed(2)}` 
                                          : "Not Available";
                                          
                                        return (
                                          <li key={`${tax.tax_name}-${key}`} className="flex items-center space-x-2 mb-1">
                                            <span>{key.replace(/_/g, " ")}:</span>
                                            <input
                                              type="text"
                                              value={formattedPrice}
                                              className="w-24 border border-gray-300 rounded px-2 py-1 bg-gray-50"
                                              readOnly
                                            />
                                          </li>
                                        );
                                      })}
                                  </ul>
                                </div>
                              );
                            })}
                          </>
                        ) : (
                          // Fallback to using the general tax percentage if no specific tax details are available
                          <>
                            <p className="text-sm font-medium text-gray-600 mb-1">With Tax ({taxPercentage}%):</p>
                            <ul className="list-disc pl-4 text-gray-500">
                              {selectedTicketCategories[attractionName]?.price &&
                                Object.entries(
                                  selectedTicketCategories[attractionName]?.price
                                ).map(([key, value]) => {
                                  // Remove currency symbols (like $) before parsing the value
                                  const cleanValue = typeof value === 'string' ? value.replace(/[^0-9.-]+/g, '') : value;
                                  
                                  // Calculate price with tax using the formula: basePrice * ((100 + taxPercentage) / 100)
                                  const basePrice = parseFloat(cleanValue) || 0;
                                  const priceWithTax = basePrice * ((100 + taxPercentage) / 100);
                                  
                                  // Format to 2 decimal places if it's a valid number and add $ symbol
                                  const formattedPrice = !isNaN(priceWithTax) && basePrice > 0 
                                    ? `$ ${priceWithTax.toFixed(2)}` 
                                    : "Not Available";
                                    
                                  return (
                                    <li key={`tax-${key}`} className="flex items-center space-x-2 mb-1">
                                      <span>{key.replace(/_/g, " ")}:</span>
                                      <input
                                        type="text"
                                        value={formattedPrice}
                                        className="w-24 border border-gray-300 rounded px-2 py-1 bg-gray-50"
                                        readOnly
                                      />
                                    </li>
                                  );
                                })}
                            </ul>
                          </>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">
            Type:
          </label>
          <select
            value={type}
            onChange={(e) => setType(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded mt-1"
          >
            <option value="Optional">Optional</option>
            <option value="Mandatory">Mandatory</option>
          </select>
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">
            Inclusion/Exclusion:
          </label>
          <div className="flex space-x-4 mt-1">
            <button
              onClick={() => setInclusion(true)}
              className={`px-4 py-2 rounded border w-full text-center ${
                inclusion
                  ? "bg-blue-500 text-white"
                  : "bg-gray-100 text-gray-700"
              }`}
            >
              Included
            </button>
            <button
              onClick={() => setInclusion(false)}
              className={`px-4 py-2 rounded border w-full text-center ${
                !inclusion
                  ? "bg-blue-500 text-white"
                  : "bg-gray-100 text-gray-700"
              }`}
            >
              Excluded
            </button>
          </div>
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">
            Arrangement:
          </label>
          <div className="flex space-x-4 mt-1">
            <button
              onClick={() => setArrangement("Company Arrangement")}
              className={`px-4 py-2 rounded border w-full text-center ${
                arrangement === "Company Arrangement"
                  ? "bg-blue-500 text-white"
                  : "bg-gray-100 text-gray-700"
              }`}
            >
            Company Arrangement  
            </button>
            <button
              onClick={() => setArrangement("Own Arrangement")}
              className={`px-4 py-2 rounded border w-full text-center ${
                arrangement === "Own Arrangement"
                  ? "bg-blue-500 text-white"
                  : "bg-gray-100 text-gray-700"
              }`}
            >
              Own Arrangement
            </button>
          </div>
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">
            Special Notes:
          </label>
          <textarea
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded mt-1"
          />
        </div>

        <button
          onClick={handleAdd}
          className="bg-blue-600 text-white px-4 py-2 rounded w-full mt-8"
        >
          {editData ? "Save Changes" : "Add Sightseeing"}
        </button>
      </div>
    </div>
  );
};

export default SightseeingPopup;
